export default __webpack_public_path__ + "static/media/ic_tracker_off.16359aad.svg";